import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';
export const SortIndicator = (props)=>{
    const { direction } = props;
    const icon = direction === 'asc' ? faSortUp : direction === 'desc' ? faSortDown : faSort;
    return /*#__PURE__*/ _jsx(FontAwesomeIcon, {
        icon: icon,
        fixedWidth: true
    });
};
